<template>
    <div>
        <base-crud
                crudName="Vídeos"
                newText="Novo Vídeo"
                :table="videosTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                videosTable: 'videosTable',
                videos: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'url', 'status', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id', 'name', 'url', 'status', 'category_video_id'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'name': 'Nome',
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'video/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Video/Crud.vue